import { useEffect, useState } from "react";
import { useStripe } from "@stripe/react-stripe-js";
import { createCheckoutSession } from "../firebase/firebase";

export default function Upgrade() {
  const stripe = useStripe();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const redirectToStripe = async () => {
      if (!stripe) {
        console.error("Stripe.js has not loaded yet.");
        return;
      }

      setLoading(true);

      try {
        // Call your cloud function to create a Stripe Checkout session
        const { data } = await createCheckoutSession();

        const sessionId = data.sessionId;

        // Redirect the user to the Stripe Checkout page
        const { error: stripeError } = await stripe.redirectToCheckout({
          sessionId,
        });

        if (stripeError) {
          setError(stripeError.message);
          setLoading(false);
        }
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    redirectToStripe();
  }, [stripe]); // Run when `stripe` is available

  return (
    <div>
      {loading && (
        <div className="flex-center mt-32">
          <div className="loader"></div>
          <p> Redirecting to payment...</p>
        </div>
      )}
      {error && <p style={{ color: "red" }}>Error: {error}</p>}
    </div>
  );
}
